import React from 'react';
import Logo from '../../Logo/Logo';
import 'bootstrap/dist/css/bootstrap.min.css';
//import 'bootstrap/dist/css/bootstrap-theme.min.css'; 
//import '../../../index.css'
import './Toolbar.css';
import '../../../base.scss'
import NavigationItems from '../NavigationItems/NavigationItems';

const toolbar = props => (
  <header className="Toolbar">
    
    <NavigationItems />
    
  </header>
);

export default toolbar;



// WEBPACK FOOTER //
// ./src/components/Header/Toolbar/Toolbar.js